import Vue from 'vue';
import DEVICE_TYPE from '@/constants/DeviceType';
import { LANG_CONST } from '@/components/devices/OperatorWorkspace/config';

class LanguageService {
  getAvailableLanguages({ device, languages }) {
    const getLanguagesFn = languages
      ? this.getUnitLanguages.bind(this, languages)
      : this.getSystemLanguages.bind(this);

    return new Promise((resolve, reject) => {
      return getLanguagesFn()
        .then(({ availableLanguagesArray, defaultLanguage }) => {
          const takeLanguageFromLocalStorage = device.device_type === DEVICE_TYPE.REGISTRATOR || device.device_type === DEVICE_TYPE.OPERATOR_WORKSPACE;

          const activeLanguage = takeLanguageFromLocalStorage
            ? this.getActiveLanguage(defaultLanguage)
            : defaultLanguage;
  
          this.getConstants(activeLanguage)
            .then((constants) => {
              if (takeLanguageFromLocalStorage) {
                this.setLanguage(activeLanguage);
              }

              resolve({
                availableLanguages: availableLanguagesArray,
                activeLanguage: activeLanguage,
                activeLanguageConsts: constants.data
              });
            })
            .catch((err) => reject(err));
        })
        .catch(reject)
    });
  }

  getUnitLanguages(languages) {
    return new Promise((resolve, reject) => {
      const availableLanguagesArray = [];
      const mainLanguage = languages.find(language => language.is_main);

      for (const language of languages) {
        availableLanguagesArray.push({
          id: language.tag,
          title: language.name,
          value: language.tag,
          tag: `(${language.tag})`
        });
      }

      resolve({
        availableLanguagesArray,
        defaultLanguage: mainLanguage ? mainLanguage.tag : nill
      });
    });
  }

  getSystemLanguages() {
    return new Promise((resolve, reject) => {
      Vue.prototype.$crudService.get('lang/')
        .then((resp) => {
          const availableLanguagesData = resp.data;
          const availableLanguagesArray = [];
          let defaultLanguage;

          if (availableLanguagesData) {
            if (availableLanguagesData && availableLanguagesData.length) {
              availableLanguagesData.forEach(lang => {
                if (lang.is_default) defaultLanguage = lang.tag;
                availableLanguagesArray.push({
                  id: lang.tag,
                  title: lang.name,
                  value: lang.tag,
                  tag: `(${lang.tag})`
                });
              })
            }

            resolve({
              availableLanguagesArray,
              defaultLanguage
            });
          }
        })
        .catch((err) => reject(err));
    });
  }
 
  getConstants(lang) {
    return Vue.prototype.$crudService.get(`lang/${lang}`)
  }

  getActiveLanguage(defaultLanguage) {
    const currentLanguage = this.getLanguage();
    return currentLanguage ? currentLanguage : defaultLanguage;
  }

  getLanguage() {
    return localStorage.getItem(LANG_CONST);
  }

  setLanguage(lang) {
    localStorage.setItem(LANG_CONST, lang);
  }

  changeLanguage(lang) {
    return new Promise((resolve, reject) => {
      this.getConstants(lang)
        .then((resp) => {
          const constants = resp.data;

          if (constants) {
            this.setLanguage(lang);
            Vue.prototype.$store.activeLanguage = lang;
            Vue.prototype.$store.activeLanguageConsts = constants;
            resolve(lang);
          } else {
            reject(false);
          }
        })
        .catch((err) => reject(err));
    });
  }

  translateFilter(value, params) {
    if (Vue.prototype.hasOwnProperty('$store') && Object.keys(Vue.prototype.$store.activeLanguageConsts).find(item => item === value)) {
      let string = Vue.prototype.$store.activeLanguageConsts[value];

      if (params) {
        Object.keys(params).forEach(k => {
          string = string.replace(`{{${k}}}`, params[k]);
          let variants = string.substring(string.lastIndexOf(`${k}:#`) + k.length + 2, string.lastIndexOf("#"));
          if (variants) {
            let variantsArray = variants.split('|');
            let cases = [2, 0, 1, 1, 1, 2];
            let finalVariant = variantsArray[(params[k] % 100 > 4 && params[k] % 100 < 20) ? 2 : cases[(params[k] % 10 < 5) ? params[k] % 10 : 5]];
            string = string.replace(`${k}:#${variants}#`, finalVariant)
          }
        });
      }
      return string;
    } else {
      return 'missing translation';
    }
  }
}

export default LanguageService;
